/**
 * Sign-in screen placeholder.
 *
 * Later replaced by the real login flow (password + Google, MFA challenge —
 * Req 22-23). Loaded lazily per route (see `screens.tsx`).
 */
import type { ReactElement } from "react";

export default function SignInScreen(): ReactElement {
  return (
    <section aria-labelledby="screen-heading" data-screen="signIn">
      <h1 id="screen-heading">Sign in</h1>
      <p>Authentication screens plug in here.</p>
    </section>
  );
}
